import { ComposableTable } from '@abtasty/design-system';
import { styled } from 'styled-components';

export const HeaderWrapper = styled.div`
  position: sticky;
  top: -27px;
  background: ${({ theme }) => theme.dec.color.primary.default.bg.norm};
  z-index: 4; // This value let the dropdown menu to be on top, and the table content to be below
`;

export const HeaderRow = styled(ComposableTable.HeaderRow)`
  gap: 0 !important;
  border-color: ${({ theme }) => theme.dec.color.primary.default.sk.norm};
`;

export const EmptyTableMessage = styled.p`
  text-align: center;
`;

export const Cell = styled(ComposableTable.Cell)`
  min-width: ${({ width }) => `${width}%`};
  display: flex;
  flex-direction: row;
  gap: 4px;
`;
